import React, { useState } from 'react';
import { MessageSquare, Send, Bot, User, RotateCcw } from 'lucide-react';
import './MockInterviewPage.css';

const MockInterviewPage = () => {
  const [position, setPosition] = useState('');
  const [started, setStarted] = useState(false);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);

  const startInterview = () => {
    if (!position.trim()) return;
    setStarted(true);
    setMessages([
      { role: 'ai', text: `Merhaba! ${position} pozisyonu için mülakat simülasyonuna hoş geldiniz. Hazır olduğunuzda "Başla" yazın.` },
    ]);
  };

  const sendMessage = async () => {
    if (!input.trim() || loading) return;
    const userMsg = input.trim();
    setInput('');
    setMessages(prev => [...prev, { role: 'user', text: userMsg }]);
    setLoading(true);

    try {
      // TODO: API entegrasyonu — POST /api/Career/MockInterview { position, messages, userMessage }
      await new Promise(r => setTimeout(r, 1500));
      setMessages(prev => [
        ...prev,
        { role: 'ai', text: 'Bu güzel bir cevaptı. Şimdi bir sonraki soruya geçelim: Bu pozisyonda karşılaşabileceğiniz en büyük zorluk ne olabilir ve nasıl çözersiniz?' },
      ]);
    } catch {
      setMessages(prev => [...prev, { role: 'ai', text: 'Bir hata oluştu. Lütfen tekrar deneyin.' }]);
    } finally {
      setLoading(false);
    }
  };

  const reset = () => {
    setStarted(false);
    setMessages([]);
    setPosition('');
    setInput('');
  };

  return (
    <div className="interview-page">
      <div className="interview__container">
        {!started ? (
          <div className="interview__start">
            <MessageSquare size={32} className="interview__start-icon" />
            <h1 className="interview__title">Deneme Mülakatı</h1>
            <p className="interview__subtitle">Yapay zeka ile mülakat pratiği yap. Başvurmak istediğin pozisyonu yaz.</p>
            <div className="interview__start-form">
              <input
                className="interview__position-input"
                placeholder="Örn: Frontend Developer, Satış Uzmanı..."
                value={position}
                onChange={(e) => setPosition(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && startInterview()}
              />
              <button className="interview__start-btn" onClick={startInterview}>
                Mülakata Başla
              </button>
            </div>
          </div>
        ) : (
          <div className="interview__chat">
            <div className="interview__chat-header">
              <div>
                <h2 className="interview__chat-title">Mülakat: {position}</h2>
                <p className="interview__chat-hint">Yapay zeka mülakatçınız sizinle konuşuyor</p>
              </div>
              <button className="interview__reset-btn" onClick={reset}>
                <RotateCcw size={14} /> Yeniden Başla
              </button>
            </div>

            <div className="interview__messages">
              {messages.map((msg, i) => (
                <div key={i} className={`interview__msg interview__msg--${msg.role}`}>
                  <div className="interview__msg-avatar">
                    {msg.role === 'ai' ? <Bot size={16} /> : <User size={16} />}
                  </div>
                  <div className="interview__msg-bubble">{msg.text}</div>
                </div>
              ))}
              {loading && (
                <div className="interview__msg interview__msg--ai">
                  <div className="interview__msg-avatar"><Bot size={16} /></div>
                  <div className="interview__msg-bubble interview__msg-typing">
                    <span></span><span></span><span></span>
                  </div>
                </div>
              )}
            </div>

            <div className="interview__input-area">
              <input
                className="interview__input"
                placeholder="Cevabınızı yazın..."
                value={input}
                onChange={(e) => setInput(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && sendMessage()}
                disabled={loading}
              />
              <button className="interview__send-btn" onClick={sendMessage} disabled={!input.trim() || loading}>
                <Send size={16} />
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MockInterviewPage;
